/**
 * Default colors for the chart
 * If you need to change the colors, do it here and here only.
 */
export const defaultColors : string[] = ['#1a56ec', '#f2644c', '#1b3160', '#9c8d87', '#26625d', '#7791e8', '#8c1131', '#878eaf', '#c73268', '#288c72'];